import './location-section.scss';
import AOS from 'aos';

export default () => {
	$( '#location' ).on( 'click', '#load-more', function ( e ) {
		e.preventDefault();
		let nextPage = $( this ).attr( 'href' );

		if ( nextPage ) {
			$( this ).parent().remove();
			$( '#location' ).append(
				$( '<div />' ).load( `${nextPage} #location` )
			);
		}
	} );

	AOS.init( {
		duration: 800,
		once: true,
	} );
};
